// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3RfED","alertIcon":"ConfirmModal_alertIcon__2qSnA"};